import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import './flags_wasm';
import { registerBackend } from '@tensorflow/tfjs-core';
import { BackendWasm, init } from './backend_wasm';
export { BackendWasm, setWasmPath, setWasmPaths } from './backend_wasm';
export { version as version_wasm } from './version';
var WASM_PRIORITY = 2;
registerBackend('wasm', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  var _yield$init, wasm;

  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return init();

        case 2:
          _yield$init = _context.sent;
          wasm = _yield$init.wasm;
          return _context.abrupt("return", new BackendWasm(wasm));

        case 5:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
})), WASM_PRIORITY);